export const getSportTerminology = (sportName) => {
  if (!sportName) return "Point";
  const sport = sportName.toLowerCase();
  switch (sport) {
    case "badminton":
    case "tennis":
    case "table tennis":
    case "volleyball":
      return "Point";
    case "football":
    case "soccer":
    case "basketball":
    case "hockey":
      return "Goal";
    case "cricket":
    case "baseball":
      return "Run";
    default:
      return "Point";
  }
};

export const getParticipantName = (match, participant) => {
  if (!match) return participant;

  // Drop-in matches store team names in match_config.drop_in_teams
  const dit = (match.matchConfig || match.match_config)?.drop_in_teams;
  if (dit) {
    return participant === 'participant1'
      ? (dit.team_a?.name || 'Team A')
      : (dit.team_b?.name || 'Team B');
  }

  if (participant === "participant1") {
    return (
      match.participant_1_name ||
      match.participant1Name ||
      (match.participant1FirstName && match.participant1LastName
        ? `${match.participant1FirstName} ${match.participant1LastName}`
        : "Player 1")
    );
  }

  if (participant === "participant2") {
    return (
      match.participant_2_name ||
      match.participant2Name ||
      (match.participant2FirstName && match.participant2LastName
        ? `${match.participant2FirstName} ${match.participant2LastName}`
        : "Player 2")
    );
  }

  return participant;
};
